import { render } from "./homeView.vue?vue&type=template&id=22e8966f"
import script from "./homeView.vue?vue&type=script&lang=js"
export * from "./homeView.vue?vue&type=script&lang=js"

import exportComponent from "I:\\Dev\\Projects\\LabManagement\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__